import { MEDIA_CONVERTER_URL } from './utils/env';

const Appconfig = {
  IMAGE_OPTI_URL: MEDIA_CONVERTER_URL,
};

export default Appconfig;
